import type { Hall } from '../api/types';

/**
 * How long a venue carries the "New" badge: this many days from the moment it
 * was listed (the hall's created_at). The one place the rule lives — the venue
 * card, the venue page and the home page all read it from here.
 */
export const NEW_LISTING_DAYS = 30;

const DAY_MS = 86_400_000;

/** True while the venue is within NEW_LISTING_DAYS of being listed. */
export function isNewListing(hall: Pick<Hall, 'created_at'>, now = Date.now()): boolean {
  const listed = Number(hall.created_at);
  return Number.isFinite(listed) && listed > 0 && now - listed < NEW_LISTING_DAYS * DAY_MS;
}
